import { procurementAPI } from "../../axios";

export const actions = {
    // PRItem
    CreateSinglePRItem(context, data){
        return procurementAPI.post(`MigrationPrItem/Create`, data);
    },
    CreateMultiplePRItem(context, data){
        return procurementAPI.post(`MigrationPrItem/Create/Multiple`, data);
    },
    GetSinglePRItem(context, data){
        return procurementAPI.get(`MigrationPrItem/${data}`);
    },
    UpdatePRItem(context, data){
        return procurementAPI.put(`MigrationPrItem/${data.id}`, data);
    },
    DeletePRItem(context, data){
        return procurementAPI.delete(`MigrationPrItem/${data}`);
    },
    GetPRItemByPR(context, data){
        return procurementAPI.get(`MigrationPrItem/PR/${data}`);
    },
}